var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowMobile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 53,
    viewBox: "0 0 270 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000976562,
    y: 29,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.999,
    y: 29,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.999,
    y: 29,
    width: 149,
    height: 6,
    rx: 3,
    fill: "#6DFBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.722 53.0002H230.364L245.68 33.6519L225.999 13.9712H239.905C241.105 13.9712 242.073 14.9397 242.073 16.1395C242.073 17.3393 241.105 18.3077 239.905 18.3077H236.465L251.476 33.3195L239.327 48.6636H249.771L265.744 30.6019C266.539 29.7057 267.912 29.6189 268.801 30.414C269.697 31.209 269.784 32.575 268.989 33.4712L251.715 52.993L251.722 53.0002Z",
    fill: "#6DFBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.162 27.6313C260.583 27.6313 259.998 27.4 259.572 26.9375L240.057 5.97746C239.24 5.10292 239.291 3.72968 240.165 2.91296C241.04 2.09624 242.413 2.14683 243.23 3.02137L262.744 23.9814C263.561 24.8559 263.511 26.2292 262.636 27.0459C262.217 27.4362 261.689 27.6241 261.162 27.6241V27.6313Z",
    fill: "#6DFBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.944 13.0098C267.812 13.0098 268.506 13.7108 268.506 14.5709C268.506 15.431 267.804 16.1321 266.944 16.1321C266.084 16.1321 265.376 15.431 265.376 14.5709C265.376 13.7108 266.077 13.0098 266.944 13.0098Z",
    fill: "#6DFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.913 7.22754C263.192 7.22754 264.233 8.26831 264.233 9.5476C264.233 10.8269 263.192 11.8677 261.913 11.8677C260.634 11.8677 259.593 10.8269 259.593 9.5476C259.593 8.26831 260.634 7.22754 261.913 7.22754Z",
    fill: "#6DFBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.703 0C258.3 0 259.594 1.29374 259.594 2.89104C259.594 4.48834 258.3 5.78207 256.703 5.78207C255.105 5.78207 253.812 4.48834 253.812 2.89104C253.812 1.29374 255.105 0 256.703 0Z",
    fill: "#6DFBFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-mobile.11acd332c9d6dd77bd78f948b3db1320.svg";